export type Version = {
  major: number;
  minor: number;
  patch: number;
};

export type VersionModifier = '=' | '~' | '>' | '<' | '==' | '~=' | '>=' | '<=';

export type VersionWithModifier = {
  modifier: VersionModifier;
  version: Version;
};

export function parseVersion(
  s: string,
  defaultModifier: VersionModifier,
): VersionWithModifier | undefined {
  const match = /^\s*(?:([=~><])(=?))?\s*(\d+)\.(\d+)(?:\.(\d+))?\s*$/.exec(s);
  if (!match) return undefined;
  const modifier =
    (match[1] ? `${match[1]}${match[2]}` : undefined) ?? defaultModifier;
  return {
    modifier: modifier as VersionModifier,
    version: {
      major: Number(match[3]),
      minor: Number(match[4]),
      patch: Number(match[5] ?? '0'),
    },
  };
}

export function parseVersionPlain(s: string) {
  return parseVersion(s, '=')?.version;
}

export function compareVersion(x: Version, y: Version) {
  return x.major > y.major
    ? 1
    : x.major < y.major
    ? -1
    : x.minor > y.minor
    ? 1
    : x.minor < y.minor
    ? -1
    : x.patch > y.patch
    ? 1
    : x.patch < y.patch
    ? -1
    : 0;
}
